<div class="h-30"></div>
<div class="form-fields">
<mat-form-field appearance="outline" floatLabel="always" [hidden]="updateUser.isParticipant">
    <mat-label>First Name</mat-label>
    <input matInput class="form-control-textbox" name="fname" [(ngModel)]="updateUser.firstName" />
   </mat-form-field>
</div>
  <div class="mb-10"></div>

  <div class="form-fields">
  <mat-form-field appearance="outline" floatLabel="always" [hidden]="updateUser.isParticipant">
    <mat-label>Last Name</mat-label>
    <input matInput class="form-control-textbox" name="lname" [(ngModel)]="updateUser.lastName" />
   </mat-form-field>
   </div>
  <div class="mb-10"></div>

  <div class="form-fields">
    <mat-form-field appearance="outline" floatLabel="always" [hidden]="!updateUser.isParticipant">
      <mat-label>{{'displayNameText'|translate:translations}}</mat-label>
      <input matInput class="form-control-textbox" name="dname" [(ngModel)]="updateUser.displayName"  />
     </mat-form-field>
     </div>
    <div class="mb-10"></div>

    <div class="form-fields">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>{{'emailText'|translate:translations}}</mat-label>
          <input matInput class="form-control-textbox" name="email" [(ngModel)]="updateUser.email"  />
         </mat-form-field>
         </div>
        <div class="mb-10"></div>
